var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "p-3 term", attrs: { outlined: "", "max-height": "250" } },
    [
      _c("div", { staticClass: "terms-in-use" }, [
        _c("div", { staticClass: "box" }, [
          _c("h1", [_vm._v("受講規約")]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("p", [
              _vm._v(
                "\n          株式会社スキルハブ（以下、「当社」）は、当社が運営するオンラインラーニングサービスskillhub（以下、「本サービス」）の利用について、以下のとおり利用規約（以下、「本利用規約」）を定めます。利用者の皆様（以下、「会員」）が本サービスを利用するためには、本利用規約の全てに同意して頂く必要があり、会員が本サービスに登録・利用したときは、会員は本利用規約に同意したものとみなします。\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("1条　本サービス")]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _vm._v(
                  "当社は本サービスを通じ、ビデオ、テキストブック、Skype、Google Hangout、チャットなどを利用したコーチングなど、様々なコンテンツの学びを会員に提供致します。"
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "本サービス内で提供するコンテンツは、当社の判断により随時変更されるものとし、サービス内容・種類変更における会員に生じる損害は、当社は一切責任を負いません。"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("2条　サービス運用について")]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _vm._v(
                  "アクセスの集中などの理由により、アクセスの中断など、会員に生じる損害に当社は一切責任を負いません。\n          "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "本サービスに登録されている会員同士のトラブルにおいて、当社は一切責任を負いません。"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("3条　著作権")]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _vm._v(
                  "本サービスが提供する授業・本サービス内での会員の提出した成果物、本サービスが制作・使用している素材などは、全て当社が著作権を有することとします。当該コメントの著作権が会員に発生したとしても、本サービス内で発信されたコメントについては、その著作権（著作権法第27条及び第28条に定める権利含む。）は、全て発信と同時に当社に移転します。"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "以下に抵触する行為を行った、または行う恐れのあるアカウントの強制停止・削除並びに法的措置を行う場合があります。"
                ),
                _c("br"),
                _vm._v(
                  "\n            (1)当社、本サービスの他の利用者又は第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為"
                ),
                _c("br"),
                _vm._v(
                  "\n            (2)当社が本サービスにおいて必要な範囲で複製、改変、送信その他の行為を行うことが本サービスの他の利用者又は第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益の侵害に該当することとなる情報を当社ウェブサイトに送信する行為。"
                ),
                _c("br"),
                _vm._v(
                  "\n            (3)犯罪行為に関連する行為又は公序良俗に反する行為"
                ),
                _c("br"),
                _vm._v(
                  "\n            (4)猥褻な情報又は青少年に有害な情報を送信する行為"
                ),
                _c("br"),
                _vm._v("\n            (5)異性交際に関する情報を送信する行為"),
                _c("br"),
                _vm._v(
                  "\n            (6)法令又は当社もしくは登録ユーザーが所属する業界団体の内部規則に違反する行為"
                ),
                _c("br"),
                _vm._v(
                  "\n            (7)コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報を送信する行為"
                ),
                _c("br"),
                _vm._v(
                  "\n            (8)本サービスに関し利用しうる情報を改ざんする行為"
                ),
                _c("br"),
                _vm._v(
                  "\n            (9)当社が定める一定のデータ容量以上のデータを本サービスを通じて送信する行為"
                ),
                _c("br"),
                _vm._v(
                  "\n            (10)当社による本サービスの運営を妨害するおそれのある行為"
                ),
                _c("br"),
                _vm._v(
                  "\n            (11)その他、当社が不適切と判断する行為\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v(" 4条　サービスの停止")]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _vm._v(
                  "以下に抵触する行為を行った、または行う恐れのあるアカウントの強制停止・削除並びに法的措置を行う場合があります。"
                ),
                _c("br"),
                _vm._v(
                  "\n            (1)本サービス提供のための装置、システムの保守または点検を行う場合"
                ),
                _c("br"),
                _vm._v(
                  "\n            (2)火災、地震などの自然災害、停電、システム障害等により本サービスの運営が困難な場合"
                ),
                _c("br"),
                _vm._v(
                  "\n            (3)コンピューターや通信回線が事故等により停止した場合"
                ),
                _c("br"),
                _vm._v(
                  "\n            (4)Youtube/facebook/google hangout等、当社が利用する外部システムが何らかの影響にて停止・不安定な状態に陥った場合"
                ),
                _c("br"),
                _vm._v(
                  "\n            (5)その他、当社がやむをえないと判断した場合"
                ),
                _c("br"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("5条　サービスの廃止")]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _vm._v(
                  "当社は、当社の判断により本サービスの提供を廃止することがあります。当社は、当該停止により会員に生じる損害には一切責任を負いません"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("6条　準拠法および合意管轄")]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [_vm._v("本利用規約の準拠法は日本法とします。")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "本利用規約に関して紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("7条　会員規約")]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _vm._v(
                  "本利用規約の一部の条項が無効とされた場合も、他の条項の効力には影響せず、他の規定は有効に存続するものとします。\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("8条 アカウント")]),
            _vm._v(" "),
            _c("ol", [
              _vm._v(
                "\n          会員は、本利用規約に同意したうえでアカウント情報(登録された情報及びアカウントに関する全ての権利、権益を含む。以下同様)の登録を行い、登録したアカウント情報を使用して、本サービスを利用することができるものとします。会員が本サービスを利用する場合には、本サービスの本利用規約の規定に従うものとします。\n          "
              ),
              _c("li", [
                _vm._v(
                  "アカウント情報で利用可能な機能追加及びその他の変更については、当社が任意に設定することができるものとし、会員はこれに同意します。"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "これらの変更に関する情報は、サービス提供画面により通知されるものとします。"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "会員は、自身が登録した自己のアカウント情報をいかなる第三者に対しても譲渡及び貸与ならびに共有できないものとします。その他いかなる目的でも、自身が登録した自己のアカウント情報を第三者に使用させることはできないものとします。"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "会員が登録したメールアドレス宛に、当社から、当社の提供するサービス及び当社が指定する第三者の提供するサービスに関連する、新機能、更新情報、キャンペーン等の案内のメールを送付するものとし、また、必要に応じて容量の大きいメールを送付する場合があり、会員はこれらに同意します。\n            メールの受信の設定については、本サービス及び送付するメールにて説明されるものとします。\n          "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "当社は、会員が自身が登録した自己のアカウント情報を使って、明示的にダウンロードが許諾されている場合を除き、ソフトウェア（記録媒体に記録されたもの及び通信回線を介して提供されるもの、並びにブラウザのアドイン等を含む）を介することにより、又は会員が指定しない第三者が提供するウェブサイトを介することにより、本サービスで視聴することのできる動画データ、並びに資料等コンテンツをダウンロードできないものとします。"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "アカウント登録時ならびにサービス利用時にFacebook/twitter等、各種ＳＮＳサービスから抽出した情報に関して、本サービスの改善・改良・開発のために利用することを会員は承認します。"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "以下の項目はアカウント登録拒否事由となり、同社の判断でアカウント登録の拒否・登録取消を行うことができるものとします。"
                ),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n          (1)本規約に違反するおそれがあると当社が判断した場合、および違反した場合"
              ),
              _c("br"),
              _vm._v(
                "\n          (2)当社に提供された登録事項の全部又は一部につき虚偽、誤記又は記載漏れがあった場合"
              ),
              _c("br"),
              _vm._v(
                "\n          (3)過去に本サービスの利用の登録を取り消された者である場合\n          (4)未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人､保佐人又は補助人の同意等を得ていなかった場合"
              ),
              _c("br"),
              _vm._v(
                "\n          (5)同一会員による、複数アカウントが確認された場合、またはその恐れがあると判断した場合"
              ),
              _c("br"),
              _vm._v(
                "\n          (6)当社、他の登録ユーザー又は第三者に損害を生じさせるおそれのある目的又は方法で本サービスを利用した、又は利用しようとした場合"
              ),
              _c("br"),
              _vm._v(
                "\n          (7)手段の如何を問わず、本サービスの運営を妨害した場合\n          (8)死亡した場合又は後見開始、保佐開始若しくは補助開始の審判を受けた場合"
              ),
              _c("br"),
              _vm._v(
                "\n          (9)6ヶ月以上本サービスの利用がなく、当社からの連絡に対して応答がない場合"
              ),
              _c("br"),
              _vm._v(
                "\n          (10)その他、当社が登録ユーザーとしての登録、並びに登録継続を適当でないと判断した場合"
              ),
              _c("br"),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-end" }, [
            _vm._v("\n        2014年4月28日制定\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box" }, [
          _c("h1", [_vm._v("プレミアムサービス（有料会員）利用規約")]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("p", [
              _vm._v(
                "\n          ｢プレミアムサービス（有料会員）利用規約｣は、会員が有料会員である【有料会員】として登録し、有料会員に対して提供されるサービスである【プレミアムサービス】を利用することに関して適用されます。会員が【有料会員】として登録しない場合には、｢プレミアムサービス（有料会員）利用規約｣は適用されません。\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("1条　規約の適用")]),
            _vm._v(" "),
            _c("ol", [
              _vm._v(
                "\n          会員は、【プレミアムサービス】への登録及び【有料会員】の利用に際して、プレミアムサービス（有料会員）利用規約に同意するものとします。【有料会員】が【プレミアムサービス】の適用を受ける各サイトを利用する際には、当該サイトの利用についてはそれぞれのサイトの利用規約に従うものとします。\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("2条【プレミアムサービス】登録")]),
            _vm._v(" "),
            _c("ol", [
              _vm._v(
                "\n          【プレミアムサービス】の登録を希望する会員は、｢プレミアムサービス（有料会員）利用規約｣に同意した後、当社所定の登録方法に従い【プレミアムサービス】への登録を行うものとします。\n          【プレミアムサービス】利用料金の支払い方法には、\n          指定振込み先口座への所定金額の振込やクレジットカード決済が適用されます。支払い方法は途中で変更することができないものとし、会員はこれに同意します。\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("3条 プレミアムサービスによる利用")]),
            _vm._v(" "),
            _c("ol", [
              _vm._v(
                "\n          有料会員】が【プレミアムサービス】を利用する場合、利用料金や内容はプレミアムサービス画面に載っています。\n          "
              ),
              _c(
                "a",
                { attrs: { href: "http://skillhub.jp/premium_services/1" } },
                [_vm._v("プレミアムサービス")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v(" 4条　譲渡等の禁止")]),
            _vm._v(" "),
            _c("ol", [
              _vm._v(
                "\n          【有料会員】は、有料会員サービスの会員たる地位やアカウント情報等を第三者に譲渡、貸与する行為や権限の共有行為、質権の設定及びその他の担保に供する行為を行えないものとし、【有料会員】はこれに同意するものとします。これらが破られた場合、アカウントの停止・解除並びに法的措置を行うものとし、その時会員に与えられる不利益において、当社は一切の責任を負いません。\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("5条　免責規定")]),
            _vm._v(" "),
            _c("ol", [
              _vm._v(
                "\n          【プレミアムサービス】では、【有料会員】に提供するサービスについて、別途同サービス上に表示する推奨環境以外の環境からの利用の動作保証を行わないものとし、推奨環境からの利用についても動作保証を行うものではなく、【有料会員】の使用する機器及び通信環境等\n          によって、提供サービスの不具合や使用する機器に不具合を及ぼす可能性があります。"
              ),
              _c("br"),
              _vm._v(
                "\n          また、当社によるメンテナンス作業や停電及び通信回線の異常、天変 地異など当社の予測を超えた不可抗力によって、サービス提供の一部又は全部に制約が生じる可能性があります。"
              ),
              _c("br"),
              _vm._v(
                "\n          また、Google hangout/google drive/Skype等、同サービスを提供する上で必要となる外部サービスによる影響を受けた場合も、当社は一切の責任を負いません。"
              ),
              _c("br"),
              _vm._v(
                "\n          【有料会員】は【プレミアムサービス】の利用に関する当社との契約締結及び契約締結後の【プレミアムサービス】の利用に際して、これらの可能性があることを十分に認識し、これらの不具合及び不具合から生じた損害についてと当社が一切免責されることに同意するものとします。\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("6条　利用停止")]),
            _vm._v(" "),
            _c("ol", [
              _vm._v(
                "\n          【有料会員】が【プレミアムサービス】の適用を受ける各サイトの利用規約に違反する行為があったときには、当社は【プレミアムサービス】による当該サイトの利用及び【プレミアムサービス】で【有料会員】に提供されていたサービスの一部又は全部の提供制限を行う場合や、\n          【有料会員】との【プレミアムサービス】の利用に関する契約を解除する場合があります。当該事由により契約解除となった場合、当社からは一切の返金が行われないものとします。"
              ),
              _c("br"),
              _vm._v(
                "\n          当社は、【プレミアムサービス】であるか否かを問わず、【プレミアムサービス】の適用を受ける各サイトの利用規約に従って、当社の権限により\n          当該サイトで提供されていたサービスの一部又は全部の利用に提供制限を行う場合があります。"
              ),
              _c("br"),
              _vm._v(
                "\n          【プレミアムサービス】であることがこれらの措置に影響を及ぼすものではなく、【プレミアムサービス】の利用に関する当社との契約は、これら当社によるサービスの提供制限を取り払うことを意味するものではありません。当社によるサービスの利用制限を理由に、当社からは一切の返金が行われないものとします。"
              ),
              _c("br"),
              _vm._v(
                "\n          利用料金の支払いがない場合には、当社は【有料会員】への通知をすることなく、【プレミアムサービス】の提供を停止することができるものとします。同内容含め、当社からの【プレミアムサービス】の提供停止による会員が被る不利益において、弊社は一切の責任を負いません。"
              ),
              _c("br"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("h3", [_vm._v("7条　提供サービスについて")]),
            _vm._v(" "),
            _c("ol", [
              _vm._v(
                "\n          【プレミアムサービス】のサービス内容の詳細については、サービス提供についての説明ページで表示されるものとし、【プレミアムサービス】への登録を希望する会員は当社との契約締結に先立ちこれらのサービス提供内容について確認し、同意のうえで当社と契約締結するものとします。"
              ),
              _c("br"),
              _vm._v(
                "\n          当社は、同サービスにおいて事前に告知することにより【プレミアムサービス】のサービス内容及び料金を変更できるものとし、【プレミアムサービス】はこれに同意するものとします。"
              ),
              _c("br"),
              _vm._v(
                "\n          【プレミアムサービス】への登録及び【有料会員】の利用に際して、会員が未成年者の場合には必ず親権者の同意を得ていることを条件とし、【プレミアムサービス】へ登録した時点で親権者の同意を得ているものとみなします。"
              ),
              _c("br"),
              _vm._v(
                "\n          また、【プレミアムサービス】へ提供されているコンテンツ・機能等は、以後廉価ならびに別形式にて提供される場合があることを了承することとします。"
              ),
              _c("br"),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-end" }, [
            _vm._v("\n        2014年4月28日制定\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box" }, [
          _c("h1", [
            _vm._v(
              "特定商取引法に基づく表記:skillhubプレミアム（有料会員）サービス"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("ol", [
              _c("li", [
                _vm._v("サービス内容／対価／提供方法"),
                _c("br"),
                _vm._v(
                  "\n            【有料会員】が【プレミアムサービス】を利用する場合、利用料金や内容はプレミアムサービス画面に掲載されています。"
                ),
                _c("br"),
                _vm._v(" "),
                _c(
                  "a",
                  { attrs: { href: "http://skillhub.jp/premium_services/1" } },
                  [_vm._v("プレミアムサービス")]
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("支払い方法"),
                _c("br"),
                _vm._v(
                  "\n            【前払い方、もしくは、クレジットカード払い\n            ※請求と支払い時期に関して／クレジットカード会社との契約内容に基づき決定されます。\n          "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("サービスの対価以外にお客様に発生する費用"),
                _c("br"),
                _vm._v("\n            ・PCを利用する場合"),
                _c("br"),
                _vm._v(
                  "\n            プレミアム（有料会員）プランのサービスを提供している各サイトにアクセスする際に発生するPCでインターネットをするために必要となる通信料、プロバイダ料金、その他インターネット利用のために必要となる料金"
                ),
                _c("br"),
                _vm._v(
                  "\n            ・携帯電話(スマートフォン含む)を利用する場合"
                ),
                _c("br"),
                _vm._v(
                  "\n            プレミアム（有料会員）プランのサービスを提供している各サイトにアクセスする際に発生するパケット通信料(発生するパケット通信料の料金は、お客様の契約形態により異なります)"
                ),
                _c("br"),
                _vm._v(
                  "\n            ・Google Hangout やskype などに関わる費用（web camera や通信費用）"
                ),
                _c("br"),
                _vm._v(
                  "\n            ・プレミアムサービス受講の際に必要となるソフトウェアの費用"
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("有料サービス提供期間 "),
                _c("br"),
                _vm._v(
                  "\n            有料サービス開始日とは、体験期間（二回）が終了して後、初めての有料コーチングサービスが実施された日になります。  "
                ),
                _vm._v(
                  "\n            有料サービスのコーチングを受講した開始日から3ヶ月間となります。\n          "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("体験受講期間 "),
                _c("br"),
                _vm._v(
                  "\n            体験受講期間とは、第１回目のコーチングサービスが実施された日になります。  "
                ),
                _vm._v(
                  "\n            体験受講期間には期限はなく、ユーザーは最大２回まで受講することができます"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("予約後のキャンセルについて "),
                _c("br"),
                _vm._v(
                  "\n            予約が確定した後のキャンセルは基本的に受け付けません  "
                ),
                _vm._v(
                  "\n            予約確定した後、予約日の前日にリマインドメールを送りますが、それに対する返信が、コーチング開始の１時間前までにない場合は、受講する意志がないものとして\n            レッスンをキャンセルいたします"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("サービス提供開始後の返金（クーリングオフ）について"),
                _c("br"),
                _vm._v(
                  "\n            【有料のサービスコーチングを受講した開始日から8日間以内であれば、いかなる理由であっても返金します。"
                ),
                _c("br"),
                _vm._v(
                  "\n            返金を希望する場合は、当社のメールアドレス（refund@skillhub.jp）に連絡することとします。"
                ),
                _c("br"),
                _vm._v(
                  "\n            クーリングオフ期間後(有料サービス開始日より8日間）のお客様都合によるキャンセルはお受けしておりません。"
                ),
                _c("br"),
                _vm._v(
                  "\n            クーリングオフ期間が終了後はいかなる理由(目標を達成できない、授業が満足でない)であっても返金は行わないものとします。"
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n              サービス提供事業者:株式会社スキルハブ"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n              利用規約の該当:同規約を承諾した場合、通常会員規約への承諾も行われたものとします。"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n              会社所在地:〒153-8573　東京都目黒区上目黒五丁目8番15号"
                  ),
                  _c("br"),
                  _vm._v("\n              代表者名:吉田光利"),
                  _c("br"),
                  _vm._v(
                    "\n              サービスに関する問い合わせ先:support@skillhub.jp までご連絡ください。"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n              ※サービスに関するお問い合わせは電話では受け付けておりません。\n            "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-end" }, [
            _vm._v("\n        2014年4月28日制定"),
            _c("br"),
            _vm._v("\n        2014年5月11日改訂"),
            _c("br"),
            _vm._v("\n        2014年５月25日改訂\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box" }, [
          _c("h1", [_vm._v("プライバシーポリシー")]),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("ol", [
              _c("li", [
                _vm._v("はじめに"),
                _c("br"),
                _vm._v(
                  "\n            当社は、当社の運営するSkillhub（以下「本サービス」といいます）において本サービスを利用する全ての方（以下「利用者」といいます）のプライバシーを尊重するために、\n            利用者の個人情報を以下の定義に従い、個人情報の適切な取り扱いに取り組んでまいります。\n          "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("個人情報の定義"),
                _c("br"),
                _vm._v(
                  "\n            個人情報とは、本サービスを通じて利用者から取得する氏名、メールアドレス、電話番号その他の利用者個人を特定できる情報のことを指します。収集する個人情報は、利用者から本サービスにてご登録いただく情報に限られます。\n          "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("個人情報の利用目的について"),
                _c("br"),
                _vm._v(
                  "\n            当社は、利用者の個人情報を以下の目的で利用することができるものとします。"
                ),
                _c("br"),
                _vm._v(
                  "\n            (1) 本サービスならびにその他本サービスに関連する情報の提供のため"
                ),
                _c("br"),
                _vm._v("\n            (2) 利用者の本人確認のため"),
                _c("br"),
                _vm._v(
                  "\n            (3) 本サービスの運営上必要な事項の通知（電子メールによるものを含むものとします。）"
                ),
                _c("br"),
                _vm._v(
                  "\n            (4) 当社及び第三者の商品等の広告または宣伝（電子メールによるものを含むものとします。）"
                ),
                _c("br"),
                _vm._v(
                  "\n            (5) 本サービスが利用者の皆様に有用だと思われるメールマガジンの送信"
                ),
                _c("br"),
                _vm._v(
                  "\n            (6) 本サービス上で、個人を特定できない範囲においての統計情報の作成および利用"
                ),
                _c("br"),
                _vm._v(
                  "\n            (7) 本サービスの新規開発に必要なデータの解析や分析"
                ),
                _c("br"),
                _vm._v(
                  "\n            (8) 利用者の皆様の行動、性別、本サービス内でのアクセス履歴などを用いたターゲティング広告の配信"
                ),
                _c("br"),
                _vm._v(
                  "\n            (9) 契約や法律等に基づく権利の行使や義務の履行"
                ),
                _c("br"),
                _vm._v(
                  "\n            (10) アフターサービス、各種問い合わせ対応のため"
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("個人情報の共有ならびに利用制限について"),
                _c("br"),
                _vm._v("\n            (1) 法令により認められた場合"),
                _c("br"),
                _vm._v("\n            (2) 利用者の皆様の同意があった場合"),
                _c("br"),
                _vm._v(
                  "\n            (3) 人の生命、身体または財産の保護のために必要があり、さらに利用者の同意を得るのが困難な場合"
                ),
                _c("br"),
                _vm._v(
                  "\n            (4) 裁判所、検察庁、警察、税務署、弁護士会またはこれらに準じた権限を持つ機関から、個人情報の開示を求められた場合"
                ),
                _c("br"),
                _vm._v(
                  "\n            (5) 本サービスの提供において当社が必要と判断した際、弁護士等、当社に対して秘密保持義務を負う者に対して開示する場合"
                ),
                _c("br"),
                _vm._v(
                  "\n            (6) 合併、営業譲渡その他の事由による事業の承継の際に、事業を承継する者に対して開示する場合"
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("個人情報の安全管理について"),
                _c("br"),
                _vm._v(
                  "\n            (1) 当社では、個人情報の漏洩または毀損の防止ならびにその他個人情報の安全管理が行われるよう、個人情報の適切な監督を行います。"
                ),
                _c("br"),
                _vm._v(
                  "\n            (2) 当社では、業務遂行に必要な範囲内で、権限を与えられた者のみが個人情報を取り扱います。"
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("個人情報の開示、訂正、削除について"),
                _c("br"),
                _vm._v(
                  "\n            当社は、個人情報保護法その他の法令等に基づき、個人情報の開示、訂正、追加、削除、利用停止、消去、第三者提供の停止、利用目的の通知の請求に対応いたします。請求が本人確認不可能な場合や、個人情報保護法の定める要件を満たさない場合、ご希望に添えない場合があります。"
                ),
                _c("br"),
                _vm._v(
                  "\n            なお、アクセスログなどの個人情報以外の情報については、原則として開示等はいたしません。\n          "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("クッキーの利用について"),
                _c("br"),
                _vm._v(
                  "\n            当社では、クッキー情報を広告掲載のために利用しております。クッキーとは、ウェブページを利用したときに、ブラウザとサーバーとの間で送受信した利用履歴や入力内容などを、お客様のコンピュータにファイルとして保存しておく仕組みです。"
                ),
                _c("br"),
                _vm._v(
                  "次回、同じページにアクセスすると、クッキーの情報を使って、ページの運営者はお客様ごとに表示を変えたりすることができます。お客様がブラウザの設定でクッキーの送受信を許可している場合、ウェブサイトは、ユーザーのブラウザからクッキーを取得できます。なお、お客様のブラウザは、プライバシー保護のため、そのウェブサイトのサーバーが送受信したクッキーのみを送信します。"
                ),
                _c("br"),
                _vm._v(
                  "お客様は、クッキーの送受信に関する設定を「すべてのクッキーを許可する」、「すべてのクッキーを拒否する」、「クッキーを受信したらユーザーに通知する」などから選択できます。設定方法は、ブラウザにより異なります。クッキーに関する設定方法は、お使いのブラウザの「ヘルプ」メニューでご確認ください。"
                ),
                _c("br"),
                _vm._v(
                  "すべてのクッキーを拒否する設定を選択されますと、認証が必要なサービスを受けられなくなる等、インターネット上の各種サービスの利用上、制約を受ける場合がありますのでご注意ください。"
                ),
                _c("br"),
                _vm._v(
                  "また、当社はお客様に適切な広告を配信する為にクッキーを利用し、以下の第三者企業が提供するサービスを利用しています。このサービスを無効にしたい場合は、こちら\n            にアクセスし、手順に従ってください。"
                ),
                _c("br"),
                _vm._v(
                  "\n\n            Google株式会社　http://www.google.co.jp/policies/technologies/ads/ "
                ),
                _c("br"),
                _vm._v(
                  "\n            ヤフー株式会社　http://btoptout.yahoo.co.jp/optout/index.html "
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("プライバシーポリシーの更新について"),
                _c("br"),
                _vm._v(
                  "\n            当社は、個人情報保護を図るため、法令等の変更や必要に応じて、本プライバシーポリシーを改訂することがあります。その際は、最新のプライバシーポリシーを本サービスに掲載いたします。本ページを都度ご確認の上、本サービスのプライバシーポリシーをご理解いただくようお願いします。\n          "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("プライバシーポリシーに関するお問い合わせ"),
                _c("br"),
                _vm._v(
                  "\n            当社のプライバシーポリシーに関するお問い合わせは、下記までご連絡お願い致します。"
                ),
                _c("br"),
                _vm._v(
                  "\n            会社所在地:〒153-8573　東京都目黒区上目黒五丁目8番15号"
                ),
                _c("br"),
                _vm._v(
                  "\n            個人情報管理責任者: support@skillhub.jp\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-end" }, [
            _vm._v("\n        2014年4月28日制定\n      "),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }